// The cards of controls the reader arranges for themselves: which order they sit in and which of them are open.
// It is a list rather than a pair of booleans because the order is the thing being edited, and a list is what a
// drag hands back — the two open flags fall out of it as the ids that are not in `closed`.

export interface Panel {
  id: string;
  title: string;
}

// Size before colour, which is the order the canvas does them in and so the order somebody works in the first time.
// Saving is not among them: it is where the page ends rather than another control to be moved above the controls.
export const PANELS: Panel[] = [
  { id: "shape", title: "Size and shape" },
  { id: "colour", title: "Colour" },
];

export const PANEL_ORDER: string[] = PANELS.map((panel) => panel.id);

export function panelTitle(id: string): string {
  return PANELS.find((panel) => panel.id === id)?.title ?? id;
}

// The dragged card taken out and put back where it was dropped. An id the order does not hold, or one dropped on
// itself, leaves the same array rather than a new one — a render is not worth a drag that moved nothing.
export function reorderPanels(order: string[], active: string, over: string): string[] {
  const from = order.indexOf(active);
  const to = order.indexOf(over);
  if (from < 0 || to < 0 || from === to) return order;
  const moved = [...order];
  moved.splice(to, 0, moved.splice(from, 1)[0]);
  return moved;
}

export function togglePanel(closed: string[], id: string): string[] {
  return closed.includes(id) ? closed.filter((shut) => shut !== id) : [...closed, id];
}
